<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>

    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div class="item">
              <span>医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                style="width: 150px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机号</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_phone"
                style="width: 150px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>开方时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 225px; margin-left: 10px"
                @change="search"
                clearable
              ></el-date-picker>
            </div>
            <div class="item">
              <span>患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="user_name"
                style="width: 150px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>患者手机号</span>
              <el-input
                placeholder="请输入"
                v-model="phone"
                style="width: 150px; margin-left: 10px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>药品剂型</span>
              <el-select
                v-model="drug_type"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span style="margin-right: 8px;">药房名称</span>
              <!-- <el-input
                placeholder="请输入"
                v-model="hospital_name"
                style="width: 150px; margin-left: 12px"
                @input="search"
                clearable
              ></el-input> -->
              <myInputSerch v-model="hospital_name" @update="search"></myInputSerch>
            </div>
            <div class="item">
              <span>药材保密设置</span>
              <div style="padding-top: 3px; margin-left: 10px">
                <el-radio-group
                  v-model="is_show"
                  @change="search"
                >
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="0">仅剂量保密</el-radio>
                  <el-radio :label="1">不保密</el-radio>
                  <el-radio :label="2">药材保密</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="item">
              <span>确认状态</span>
              <div style="padding-top: 3px; margin-left: 10px">
                <el-radio-group
                  v-model="is_doctor_sure"
                  @change="search"
                >
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="2">待确认</el-radio>
                  <el-radio :label="4">已驳回</el-radio>
                  <el-radio :label="3">已通过</el-radio>
                </el-radio-group>
              </div>
              <el-button
                type="primary"
                size="medium"
                style="margin-left: 20px"
                @click="search"
              >查询</el-button>
              <el-button
                size="medium"
                plain
                style="margin-left: 10px"
                @click="clearSearch"
              >重置</el-button>
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                label="开方时间"
                prop="create_time"
              ></el-table-column>

              <el-table-column
                label="医生信息"
                prop="hospital_name"
              >
                <template slot-scope="scope">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >{{ scope.row.doctor_name }}</div>
                  <div>
                    <span>{{ scope.row.doctor_sex == 1 ? "男" : "女" }}</span>
                    <span style="margin-left: 10px">{{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.doctor_phone }}</div>
                </template>
              </el-table-column>
              <el-table-column label="患者信息">
                <template slot-scope="scope">
                  <div>{{ scope.row.user_name }}</div>
                  <div>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span v-if="scope.row.sex == 0">未知</span>
                    <span style="margin-left: 15px">{{ scope.row.age }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="剂型"
                prop="drug_type_name"
              ></el-table-column>
              <el-table-column
                label="药房名称"
                prop="hospital_name"
              ></el-table-column>
              <el-table-column label="处方图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.pre_picture"
                    :preview-src-list="[scope.row.pre_picture]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column label="药材保密设置">
                <template slot-scope="scope">
                  <div v-if="scope.row.is_show==0">仅剂量保密</div>
                  <div v-if="scope.row.is_show==1">不保密</div>
                  <div v-if="scope.row.is_show==2">药材保密</div>
                </template>
              </el-table-column>
              <el-table-column label="诊后管理">
                <template slot-scope="scope">
                  <div>{{ scope.row.is_consult_drug ? "开启" : "关闭" }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="诊金"
                prop="consulting_gold"
              ></el-table-column>
              <el-table-column
                label="客服备注"
                prop="remark"
              ></el-table-column>
              <el-table-column label="处方状态">
                <template slot-scope="scope">
                  <div style="text-align: left">
                    <span v-if="scope.row.status == 1">待取药</span>
                    <span v-if="scope.row.status == 2">待审方</span>
                    <span v-if="scope.row.status == 3">已通过</span>
                    <span v-if="scope.row.status == 4">已抓药</span>
                    <span v-if="
                        scope.row.status == 5 ||
                        scope.row.status == 6 ||
                        scope.row.status == 7 ||
                        scope.row.status == 8
                      ">已失效</span>
                  </div>
                  <div style="text-align: left">
                    <span v-if="scope.row.is_doctor_sure == 2">（待确认）</span>
                    <span v-if="scope.row.is_doctor_sure == 3">（已通过）</span>
                    <span v-if="scope.row.is_doctor_sure == 4">（已驳回）</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="toDetail(scope.row.pre_id)"
                  >查看处方</el-button>
                  <el-button
                    type="text"
                    @click="toVoid(scope.row.pre_id)"
                    v-if="scope.row.status == 1"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('445')
                        : false
                    "
                  >作废</el-button>
                  <el-button
                    type="text"
                    v-if="
                      scope.row.is_doctor_sure == 4 && scope.row.status == 1
                    "
                    @click="toPre(scope.row.pre_id)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('446')
                        : false
                    "
                  >重新划价</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import myInputSerch from '@/components/myInputSerch';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      doctor_name: '',
      doctor_phone: '',
      date: [],
      user_name: '',
      phone: '',
      drug_type: '',
      hospital_name: '',
      is_show: '',
      is_doctor_sure: '',
      options: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg,myInputSerch
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_phone: this.doctor_phone,
        doctor_name: this.doctor_name,
        user_name: this.user_name,
        phone: this.phone,
        drug_type: this.drug_type,
        hospital_name: this.hospital_name,
        is_show: this.is_show,
        is_doctor_sure: this.is_doctor_sure,
        is_calculate_price: 1
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/photograph/getPhotoPrescriptionList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    clearSearch() {
      this.doctor_phone = '';
      this.doctor_name = '';
      this.user_name = '';
      this.phone = '';
      this.drug_type = '';
      this.hospital_name = '';
      this.is_show = '';
      this.data = [];
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //详情
    toDetail(pre_id) {
      this.$router.push({
        path: 'doctorpredetail',
        query: {
          pre_id
        }
      });
    },
    //重新划价
    toPre(pre_id) {
      this.$router.push({
        path: 'savepreagain',
        query: {
          pre_id
        }
      });
    },
    //作废
    toVoid(pre_id) {
      this.$confirm('确定作废拍方记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/photograph/delPhotoPrescription', { pre_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('记录已作废');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post('platform/photograph/getDrugTypeList', { platform_type })
        .then((res) => {
          this.options = res.data.list;
        });
    }
  },
  created() {
    this.getList();
    this.getDrugTypeList();
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 200px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      margin-right: 30px;
      margin-top: 16px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.dialog {
  padding: 20px 20px 0;
}
</style>